import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

export const show = async ({ id }) => {
  let response = {};

  try {
    response = await axiosInstance.get(`/transaction/license/${id}`);

    //* Test for caching - TODO look into way to revalidate
    // response = await axiosInstanceCached.get(`/transaction/license/${id}`, {
    //   cache: {
    //     ttl: 1000 * 60 * 15,
    //     override: overrideCache,
    //   },
    // });
    // console.log('transaction show response:', response);
    // console.log('transaction show cached:', response.cached);
    // // console.log('transaction show ttl:', response.config?.cache?.ttl);
    // // console.log('transaction show config:', response.config);
    // console.log('transaction show duration:', response.duration);
    // console.log('============================');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
